









































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
/** 案件情報登録 **/
import AdvanceCreditInformationTab from '@/components/common/modules/tabs/matter/AdvanceCreditInformationTab.vue';
import MainCreditInfomationTab from '@/components/common/modules/tabs/matter/MainCreditInfomationTab.vue'
import MaterialListTab from '@/components/common/modules/tabs/matter/MaterialListTab.vue'
import FixedMatterInformationTab from '@/components/common/modules/tabs/matter/FixedMatterInformationTab.vue'
import FixedMatterInformationGeneralTab from '@/components/common/modules/tabs/matter/FixedMatterInformationGeneralTab.vue'
/** 見積作成画面、見積詳細画面 */
import ConfigurationTable from '@/components/common/modules/tabs/estimate/ConfigurationTable.vue';
import EstimateInformation from '@/components/common/modules/tabs/estimate/EstimateInformation.vue';
import RateTable from '@/components/common/modules/tabs/estimate/RateTable.vue';

@Component({
  components: {
    AdvanceCreditInformationTab,
    MainCreditInfomationTab,
    MaterialListTab,
    FixedMatterInformationTab,
    FixedMatterInformationGeneralTab,
    ConfigurationTable,
    EstimateInformation,
    RateTable
  }
})
export default class RateTabPanel extends Vue {
  
  @Prop({ default: false })
  private isScrren?: boolean;
  @Prop({ default: () => ({}) })
  private tabData: any;
  @Prop({ default: 0 })
  private selectedTabIndex!: number;
  @Prop({ default: false })
  private isEager?: boolean;

  private tabViewValue = `tab-${this.selectedTabIndex}`;
  private items: any = [];

  created() {
    for (const data of this.tabData) {
      this.items.push(data);
    }
  }

  @Watch('tabData')
  private onChangeTabData() {
    // tabDataが切り替わったら先頭のタブに移動する
    this.tabViewValue = `tab-0`;

    this.items.splice(0);
    for (const data of this.tabData) {
      this.items.push(data);
    }
  }

  
  /**
   * 子コンポーネントからEmitされた値を親コンポーネントにEmitで渡す
   * @module tabChildrenEventRelay
   * @param response - 子コンポーネントからEmitされた値
   * @return response - 子コンポーネントからEmitされた値
   */
  @Emit('tabChildrenEventRelay')
  private tabChildrenEventRelay(response: any) {
    return response;
  }
  /**
   * 子コンポーネントからEmitされた値を親コンポーネントにEmitで渡す
   * @module clickFixedMatter
   * @param response - 子コンポーネントからEmitされた値
   * @return response - 子コンポーネントからEmitされた値
   */
  @Emit('clickFixedMatter')
  private clickFixedMatter(response: any) {
    return response;
  }
}
